import React from "react";
import { NavBar } from "./navigation/desktop/nav-bar";
import { MobileNavBar } from "./navigation/mobile/mobile-nav-bar";
import { PageFooter } from "./page-footer";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const PageLayout = ({ children }) => {
  return (
    <div className="page-layout">
        <ToastContainer autoClose={2000} position={"top-left"} />
        <NavBar />
      <MobileNavBar />
      <div className="page-layout__content">{children}</div>
      <PageFooter />
    </div>
  );
};
